import {inject} from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import {AuthenticationService} from './authentication.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthenticationService);
  if (!authService.isAuthenticated()) {
    const loginPath = router.parseUrl("/login");
    return new RedirectCommand(loginPath, { replaceUrl: true });
  }
  return true;
};
